import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getOutputColumnsData,
  getMappings,
  saveAsMappings,
  getInputColumnsData,
} from "../store/workspaceSlice";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import MultiselectComponent from "../components/MultiselectComponent";
import { rulesProperties, allowedRules } from "../helpers";
import InputField from "../components/InputField";
import { dateFormats } from "../components/InputColumnForm";
import CheckBox from "../components/CheckBox";
import { sortObjectByKeys } from "../utils";
const initialObjectProperties = {
  inputColumns: [],
  outputColumn: "",
  toDateFormat: "",
  switchColMappings: {},
  useOutputOf: null,
  appliedRule: 9,
};

const DateAndCodeCombination = () => {
  const dispatch = useDispatch();
  const [dateAndCodeObject, setDateAndCodeObject] = useState(
    initialObjectProperties
  );
  const [selectedInputs, setSelectedInputs] = useState();
  const inputColsData = useSelector(getInputColumnsData);
  const outputColsData = useSelector(getOutputColumnsData);
  const currentMaps = useSelector(getMappings);

  const handleOnChange = (e) => {
    setDateAndCodeObject((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleAddNewRule = () => {
    dispatch(
      saveAsMappings({
        ...dateAndCodeObject,
        switchColMappings: sortObjectByKeys(
          dateAndCodeObject.switchColMappings
        ),
      })
    );
    setDateAndCodeObject(initialObjectProperties);
    setSelectedInputs("");
  };

  const handlesetselectInputcols = (selectedOptions) => {
    setSelectedInputs(selectedOptions);
    setDateAndCodeObject({
      ...dateAndCodeObject,
      inputColumns: [...selectedOptions.map((sel) => sel.value)],
    });
  };

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 p-2">
      <MultiselectComponent
        options={inputColsData
          .filter((item) => item.inColCharCode !== "")
          .map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
        selectedOptions={selectedInputs}
        handleSetSelect={handlesetselectInputcols}
        label={"Use Character Code Of Input Columns"}
      />

      <DropDownMenu
        label="Select Output Column"
        name="outputColumn"
        value={dateAndCodeObject.outputColumn}
        options={outputColsData.map((item) => ({
          label: item.outColChr,
          value: item.outColChr,
        }))}
        onChange={(e) => handleOnChange(e)}
        placeholder="Select output column"
      />
      <DropDownMenu
        label={"Use Output of previous Rule"}
        name="useOutputOf"
        value={dateAndCodeObject.useOutputOf || ""}
        options={currentMaps
          .filter((item) => allowedRules.includes(item.appliedRule)) // Filter items based on allowed rules
          .map((item) => ({
            label: `${item._id} :  ${
              item.appliedRule
                ? rulesProperties[item?.appliedRule].ruleName
                : item.ruleName
            }`,
            value: parseInt(item._id),
          }))}
        onChange={handleOnChange}
      />
      <DropDownMenu
        label="Select Date Format"
        name="toDateFormat"
        value={dateAndCodeObject.toDateFormat}
        options={dateFormats}
        onChange={(e) => handleOnChange(e)}
        placeholder="Select date format"
      />
      {dateAndCodeObject.outputColumn &&
        dateAndCodeObject.inputColumns.length >= 1 && (
          <div className="col-span-2 flex justify-start items-end gap-x-8">
            <div className="min-h-10 flex">
              <CheckBox
                chkBoxText={"Same as output column"}
                onChange={(e) => {
                  if (e.target.checked) {
                    setDateAndCodeObject((prevState) => ({
                      ...prevState,
                      switchColMappings: Object.fromEntries(
                        Object.keys(prevState.switchColMappings).map(
                          (key) => [key, dateAndCodeObject.outputColumn] // 0 because will work if only one output column is selected
                        )
                      ),
                    }));
                  }
                }}
              />
            </div>
          </div>
        )}

      {dateAndCodeObject?.outputColumn &&
        dateAndCodeObject?.inputColumns?.length > 0 && (
          <div className="col-span-2 w-full p-2">
            <label className="font-semibold">
              Map Character Codes of Input columns to output column
            </label>
            <div className="flex flex-wrap gap-4">
              {dateAndCodeObject.inputColumns.map((column, index) => {
                // Ensure switchColMappings has default values for all inputColumns
                if (!(column in dateAndCodeObject.switchColMappings)) {
                  setDateAndCodeObject((prevState) => ({
                    ...prevState,
                    switchColMappings: {
                      ...prevState.switchColMappings,
                      [column]: "", // Set default value if not present
                    },
                  }));
                }

                return (
                  <InputField
                    label={column}
                    key={column}
                    value={dateAndCodeObject.switchColMappings[column] || ""} // Ensure controlled input
                    type="text"
                    placeholder="A"
                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/[^a-zA-Z]/g, "")
                        .toUpperCase()
                        .trim();
                      setDateAndCodeObject((prevState) => ({
                        ...prevState,
                        switchColMappings: {
                          ...prevState.switchColMappings,
                          [column]: value, // Update only this field
                        },
                      }));
                    }}
                  />
                );
              })}
              {/* {dateAndCodeObject?.inputColumns.map((column, index) => (
                <InputField
                  label={column}
                  key={column}
                  type="text"
                  placeholder={"A"}
                  onChange={(e) => {
                    let currSwitchbyMaps = {
                      ...dateAndCodeObject?.switchColMappings,
                    };
                    const value = e.target.value
                      .replace(/[^a-zA-Z]/g, "")
                      .toUpperCase()
                      .trim();
                    e.target.value = value;
                    currSwitchbyMaps[column] = e.target.value;
                    setDateAndCodeObject({
                      ...dateAndCodeObject,
                      switchColMappings: currSwitchbyMaps,
                    });
                  }}
                />
              ))} */}
            </div>
          </div>
        )}

      <div className="mt-4 col-span-2 flex gap-2">
        <Button
          btnText={"Save"}
          handleOnClick={handleAddNewRule}
          disabled={
            dateAndCodeObject.inputColumns?.length <= 0 ||
            dateAndCodeObject.outputColumn === ""
          }
        />
        <Button
          btnType="cancel"
          btnText={"Reset"}
          handleOnClick={() => {
            setDateAndCodeObject(initialObjectProperties);
            setSelectedInputs("");
          }}
        />
      </div>
    </div>
  );
};

export default DateAndCodeCombination;
